<app-offer-details [offerId] = "idOferta" [tipoUsuario]="3"></app-offer-details>